export const validatePatientIntegrationsZus = (field, value) => {
  let errMsg = '';
  switch (field) {
    case 'zusPatientId':
      if (!value) {
        errMsg = 'ZUS patient ID should not be empty';
      }
      break;
    default:
      errMsg = '';
  }

  return { [field]: errMsg };
};
